// Meta Pixel (browser) per RINOVA. Il pixel si carica SEMPRE al primo render,
// senza alcun consenso: l'agency deve poter tracciare tutto da subito.
// Ogni evento ha un event_id condiviso con la copia lato server (Conversions API)
// per la deduplica su Meta. value sempre in EUR, con content_ids.
import axios from "axios";
import { isInternalSession, funnelTick } from "./tracking";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

let loaded = false;
let initializing = false;
const pending = []; // eventi in attesa che il pixel sia pronto

export function genEventId() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch (e) { /* noop */ }
  return "e-" + Date.now() + "-" + Math.random().toString(36).slice(2, 10);
}

function readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|;\\s*)" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[1]) : undefined;
}

function injectPixel(pixelId) {
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
}

function fire(name, data, eventId) {
  if (loaded && window.fbq) {
    window.fbq("track", name, data || {}, { eventID: eventId });
  } else {
    pending.push({ name, data, eventId });
  }
}

// Inizializza il pixel subito, senza consenso. Idempotente.
// PARTE 3: le sessioni interne (admin loggato, ?interno=1, dominio non pubblico)
// non caricano il Pixel né inviano eventi.
export function initMeta() {
  if (typeof window === "undefined") return;
  if (loaded || initializing) return;
  if (isInternalSession()) return;
  initializing = true;
  (async () => {
    try {
      const { data } = await axios.get(`${API}/meta/config`);
      const pixelId = data?.pixel_id;
      if (!pixelId) { initializing = false; return; }
      injectPixel(pixelId);
      loaded = true;
      // PageView iniziale: browser + copia server con lo stesso event_id.
      metaPageView();
      pending.splice(0).forEach((ev) => window.fbq("track", ev.name, ev.data || {}, { eventID: ev.eventId }));
    } catch (e) {
      initializing = false;
    }
  })();
}

// Invia la copia lato server (Conversions API) dello stesso evento (stesso event_id).
async function serverCopy(eventName, { eventId, value, currency = "EUR", contentIds, numItems }) {
  try {
    await axios.post(`${API}/meta/track`, {
      event_name: eventName,
      event_id: eventId,
      event_time: Math.floor(Date.now() / 1000),
      value, currency,
      content_ids: contentIds,
      num_items: numItems,
      event_source_url: window.location.href,
      fbp: readCookie("_fbp") || null,
      fbc: readCookie("_fbc") || null,
    });
  } catch (e) { /* la copia server è best-effort */ }
}

export function metaPageView() {
  if (isInternalSession()) return;
  funnelTick("page_view");
  const eventId = genEventId();
  fire("PageView", {}, eventId);
  serverCopy("PageView", { eventId });
}

export function metaViewContent({ contentId, name, value, currency = "EUR" }) {
  if (isInternalSession()) return;
  funnelTick("view_content");
  const eventId = genEventId();
  fire("ViewContent", {
    content_ids: [contentId], content_type: "product", content_name: name,
    value, currency,
  }, eventId);
  serverCopy("ViewContent", { eventId, value, currency, contentIds: [contentId] });
}

export function metaAddToCart({ contentId, name, value, currency = "EUR", quantity = 1 }) {
  if (isInternalSession()) return;
  funnelTick("add_to_cart");
  const eventId = genEventId();
  fire("AddToCart", {
    content_ids: [contentId], content_type: "product", content_name: name,
    value, currency, quantity,
  }, eventId);
  serverCopy("AddToCart", { eventId, value, currency, contentIds: [contentId], numItems: quantity });
}

export function metaInitiateCheckout({ value, currency = "EUR", numItems, contents }) {
  if (isInternalSession()) return;
  funnelTick("initiate_checkout");
  const eventId = genEventId();
  fire("InitiateCheckout", {
    value, currency, num_items: numItems,
    contents, content_type: "product",
    content_ids: (contents || []).map((c) => c.id),
  }, eventId);
  serverCopy("InitiateCheckout", { eventId, value, currency, contentIds: (contents || []).map((c) => c.id), numItems });
}

// Purchase lato browser (sulla pagina di ringraziamento): il server invia la sua
// copia con lo STESSO event_id salvato sull'ordine ("purchase_" + order_id).
export function metaPurchaseBrowser({ eventId, value, currency = "EUR", contentIds, numItems }) {
  if (isInternalSession()) return;
  funnelTick("purchase");
  fire("Purchase", {
    value, currency, content_ids: contentIds, content_type: "product", num_items: numItems,
  }, eventId);
}
